import React from "react";
import { useLocation } from "react-router-dom";

export default function TeamPageMemberCards(props) {
  let location = useLocation()
  let getTeam = location.pathname.split("/") 

  // console.log(props)
  // console.log(getTeam[2])
  // console.log(props.TeamData[getTeam[2]])


  return (
    <div id="coreteamsection" className="w-full lg:mt-10 py-24 flex justify-center flex-col items-center text-sky-800 dark:text-sky-500">
      <div className="flex flex-col items-center w-11/12 md:w-10/12">

        <div className="flex justify-start w-full flex-col ">

   {  props.TeamData[getTeam[2]].length > 0 ?

          <h1 className="text-3xl font-bold flex justify-start ">
            Explore our core team
          </h1>
          :
          <div className="dark:bg-content bg-center bg-cover hover:shadow-2xl dark:hover:shadow-gray-600 px-7 py-11 rounded-lg bg-gray-100 dark:bg-transparent cursor-pointer custom_shadow">
          <h1 className="text-3xl font-bold flex justify-start ">
         Coming soon
        </h1>
        </div>
}

          <div className="grid lg:grid-cols-3  w-full mt-16 gap-8 ">


            { props.TeamData[getTeam[2]].length > 0 && props.TeamData[getTeam[2]].map((item,index) => {
              return  <div key={index} className="dark:bg-content bg-center bg-cover hover:shadow-2xl dark:hover:shadow-gray-600 px-7 py-11 rounded-lg bg-gray-100 dark:bg-transparent cursor-pointer custom_shadow">
              <img
                src={"/img/"+item.image}
                alt=""
                className="rounded-lg"
              />
              <h1 className="text-2xl font-bold mt-20">
              {item.title}
              </h1>
              <p className="mt-2 text-gray-500 dark:text-gray-400">
              {item.desc}
              </p>
            </div>

            }  ) }
            {/* 1st card */}
          </div>

        </div>
      </div>
    </div>
  );
}
